import { render } from "./TVShows.vue?vue&type=template&id=050c8d4b&scoped=true"
import script from "./TVShows.vue?vue&type=script&lang=js"
export * from "./TVShows.vue?vue&type=script&lang=js"

import "./TVShows.vue?vue&type=style&index=0&id=050c8d4b&lang=scss"
import "./TVShows.vue?vue&type=style&index=1&id=050c8d4b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050c8d4b"]])

export default __exports__